import React, { Component } from 'react';
import { Modal } from "react-bootstrap";
import { isEmail, decode, encode, sendNotfication, wait, isPhoneValid1, isPhoneValid2 } from "../../../Helper";
import socket from "../../../Socket";
import C from "../../../Constant";
import Reset from "./Reset";

class Forget extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            loading: true,
            resetPage: false,
            disabled: false,
            showed: true,
            email: ''
        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);

    }

    componentWillMount() {
        wait(500).then(() => {
            this.setState({ loading: false });
        })
    }

    componentDidMount() {
        socket.on(C.RESET_CODE, data => this.resetPassword(decode(data)));
    }

    handleShow(e) {
        this.props.clicked();
        this.setState({ show: true });
    }

    handleClose() {
        this.setState({ show: false });
    }

    resetPass = (e) => {
        this.setState({ resetPage: !this.state.resetPage })
        this.setState({ showed: !this.state.showed })
    };

    resetPassword = (data) => {
        let response = data;

        const { t } = this.props;

        this.setState({ disabled: false });

        if (response.status) {
            this.resetPass();
            return sendNotfication(t('your reset code send to mobile_number'), 'success', 'top-center');
        }
        else {
            return sendNotfication(t(response.status), 'warning', 'top-center');
        }
    };

    submitForm(e) {
        e.preventDefault();
        const { t } = this.props;


        if (!(isPhoneValid1(this.state.email) || isPhoneValid2(this.state.email))) {

            return sendNotfication(t('please enter valid mobile number'), 'warning', 'top-center');
        }


        this.setState({ disabled: true });

        wait(700).then(() => {
            socket.emit(C.RESET_CODE, encode({ email: this.state.email }));
        })
    }

    back = () => {
        this.props.clicked();
    };

    render() {
        let { t } = this.props;
        return (
            <>
                {this.state.loading && !this.state.resetPage ?
                    <>
                        <div className="text-center">
                            <div class="spinner-border text-info my-3 user-loader" role="status" />
                        </div>
                    </>
                    :
                    <>
                        <div className="auth-form-container" style={this.state.showed ? { display: "block" } : { display: "none" }}>
                            <div className="text-center mb-4">
                                <p className="text-white opacity-70">Enter your phone number to reset your password</p>
                            </div>
                            <form className="auth-form" onSubmit={(e) => this.submitForm(e)}>
                                <div className="auth-input-wrapper">
                                    <i className="mdi mdi-cellphone" />
                                    <input
                                        type="text"
                                        className="form-control auth-input-custom"
                                        name="email"
                                        placeholder="Mobile Number (07XX)"
                                        autoComplete="off"
                                        onChange={e => this.setState({ email: e.target.value })}
                                    />
                                </div>
                                <div className="mt-4 d-flex flex-column gap-3">
                                    <button type="submit" className="auth-btn-primary mb-2" disabled={this.state.disabled}>
                                        {this.state.disabled ? (
                                            <><i className="mdi mdi-loading mdi-spin mr-2" /> Sending...</>
                                        ) : (
                                            <><i className="mdi mdi-email-send-outline mr-2" /> Send Reset Code</>
                                        )}
                                    </button>
                                    <button type="button" className="btn btn-link text-white opacity-50 font-weight-bold" onClick={this.back}>
                                        <i className="mdi mdi-arrow-left mr-1" /> Back to Login
                                    </button>
                                </div>
                            </form>
                        </div>
                    </>
                }{
                    this.state.resetPage &&
                    <Reset t={t} clicked={this.resetPass} />
                }
            </>
        );
    }
}

export default Forget;